(() => {
  const translations = {
    nl: {
      title: 'Ook wij zijn gek op koekjes 🍪',
      joke: 'Helaas zijn deze niet om op te eten — ze zorgen er wél voor dat onze snoepwinkel lekker werkt.',
    },
    en: {
      title: 'We love cookies too 🍪',
      joke: 'Sadly, these are not edible — but they do keep our candy shop running smoothly.',
    },
    de: {
      title: 'Auch wir lieben Kekse 🍪',
      joke: 'Leider nicht zum Naschen — dafür sorgen sie dafür, dass unser Süßigkeitenshop rund läuft.',
    },
    fr: {
      title: 'Nous aussi, on adore les cookies 🍪',
      joke: 'Malheureusement, ceux-ci ne se mangent pas — mais ils font tourner notre boutique tout en douceur.',
    },
  };
  const locale = document.documentElement.lang.toLowerCase().split('-')[0];
  const copy = translations[locale] || translations.en;

  const decorateCookieBanner = () => {
    const banner = document.querySelector('#shopify-pc__banner');

    if (!banner) return false;

    banner.classList.add('jc-cookie-banner');

    const title = banner.querySelector('h2, h3, [role="heading"]');

    if (title && !title.dataset.jcCookieTitle) {
      title.dataset.jcCookieTitle = 'true';
      title.textContent = copy.title;
    }

    const body = banner.querySelector('.shopify-pc__banner__body') || title?.parentElement;

    if (body && !body.querySelector('.jc-cookie-banner__joke')) {
      const joke = document.createElement('p');
      joke.className = 'jc-cookie-banner__joke';
      joke.textContent = copy.joke;

      if (title) {
        title.insertAdjacentElement('afterend', joke);
      } else {
        body.prepend(joke);
      }
    }

    return true;
  };

  if (decorateCookieBanner()) return;

  const observer = new MutationObserver(() => {
    if (decorateCookieBanner()) observer.disconnect();
  });

  observer.observe(document.documentElement, { childList: true, subtree: true });
  window.setTimeout(() => observer.disconnect(), 20000);
})();
